import { match } from 'ts-pattern';
export const migrateToV3 = (state)=>{
    return state.map((entity)=>{
        return match(entity).returnType().otherwise((other)=>other);
    });
};

//# sourceMappingURL=v3.js.map